/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Thai (Thailand): th-th
 */

/**
 * Translation file for th-TH locale
 *
 * @file th.js
 * @author Mohamed yasar arabath M
 */

const th = {
  'common.OK': 'ตกลง',
  'common.CONTINUE': 'ดำเนินการต่อ',
  'browser.check.DONT_SHOW_AGAIN': 'Don\'t show me this again',
  'browser.check.SYS_REQUIREMENTS_LINK_TEXT': 'ระบบปฏิบัติการและเว็บเบราว์เซอร์ที่รองรับ',
  'browser.check.BROWSER_MESSAGE_TITLE': 'เบราว์เซอร์ของคุณ <<name>> ล้าสมัย',
  'browser.check.BROWSER_MESSAGE_DESC': 'เพื่อประสบการณ์การใช้งานที่ดีที่สุด โปรดเลือกใช้เบราว์เซอร์รุ่นล่าสุด:',
  'browser.check.BROWSER_SKIP_NOW': 'ข้ามตอนนี้',
  'browser.check.BROWSER_SUPPORTED_LINK_TEXT': 'เกี่ยวกับเบราว์เซอร์ที่รองรับ',
  'browser.check.BROWSER_UNSUPPORTED_TITLE': 'เบราว์เซอร์ของคุณ <<name>> ไม่รองรับ',
  'browser.check.BROWSER_UNSUPPORTED_DESC': 'เพื่อประสบการณ์การใช้งานที่ดีที่สุด โปรดเลือกเบราว์เซอร์ที่รองรับ',
  'browser.check.OS_UNSUPPORTED_TITLE': 'ระบบปฏิบัติการของคุณ <<name>> ไม่รองรับ',
  'browser.check.OS_UNSUPPORTED_DESC': 'While the product may work with no issues, please be aware that any problems you encounter might be resolved by trying with a device running a <<link>>',
  'errors.GENERIC_TITLE': 'ข้อผิดพลาดของเซิร์ฟเวอร์',
  'errors.GENERIC_DESC': 'ขออภัย ระบบของเราขัดข้อง โปรดลองใหม่อีกครั้งในภายหลัง หรือติดต่อฝ่ายสนับสนุน',
  'errors.HTTP_400_TITLE': 'ข้อผิดพลาดของเซิร์ฟเวอร์',
  'errors.HTTP_400_DESC': 'เราพบข้อผิดพลาดขณะประมวลผลคำขอของคุณ',
  'errors.HTTP_401_TITLE': 'คุณเข้าสู่ระบบแล้วหรือยัง',
  'errors.HTTP_401_DESC': 'เราไม่สามารถดึงข้อมูลได้ เนื่องจากเซสชันการเข้าสู่ระบบของคุณอาจหมดอายุแล้ว',
  'errors.HTTP_403_TITLE': 'ไม่ได้รับอนุญาต',
  'errors.HTTP_403_DESC': 'You don\'t have access to this resource.',
  'errors.HTTP_888_TITLE': 'เซิร์ฟเวอร์ตอบสนองช้าเกินไป',
  'errors.HTTP_888_DESC': 'เราพบข้อผิดพลาดขณะประมวลผลคำขอของคุณ'
};

export default th;
